import { apertura } from '../data/contenido';

export default function Manifiesto() {
  return (
    <section className="manifiesto">
      <div className="envoltura">
        <blockquote data-reveal="">
          <p>«{apertura.cita}»</p>
          <cite>{apertura.autora}</cite>
        </blockquote>
      </div>
    </section>
  );
}
